import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { CookieService } from "./services/cookie.service";
import { COOKIE_CONNECT_WALLET } from "./constants";
import GAService from "./services/ga.service";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTheme, MantineProvider } from "@mantine/core";
import { WagmiProvider } from "wagmi";
import "react-toastify/dist/ReactToastify.css";
import { wagmiAdapter } from "./utils/walletConnect.service";
import { router } from "./_routes";

const origin = window.location.origin.includes("localhost")
  ? "https://flare-space-test.matheo.si"
  : window.location.origin;
loadWebComponent(origin, "/components/PromoBanner.js");
loadWebComponent(origin, "/components/FlareSpaceMenu.js");

// Dynamically load web components to avoid extensive caching.
function loadWebComponent(origin: string, srcUrl: string) {
  const newScript = document.createElement("script");
  newScript.src = `${origin}${srcUrl}?v=${Date.now()}`;
  document.head.appendChild(newScript);
}

if (import.meta.env.VITE_DEPLOY_TARGET === "production") {
  if (CookieService.cookieExists(COOKIE_CONNECT_WALLET)) {
    //Add google analytics if COOKIE_CONNECT_WALLET is found.
    // Otherwise it is initialized after cookie banner is accepted
    GAService.loadGoogleAnalytics();
  }
}

if (
  import.meta.env.VITE_DEPLOY_TARGET === "production" ||
  import.meta.env.VITE_DEPLOY_TARGET === "staging"
) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.log = function () {}; //Prevent logs on production and staging
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      retryDelay: 1000,
      refetchOnWindowFocus: false, // default: true
    },
  },
});

const theme = createTheme({
  cursorType: "pointer",
  fontFamily: "IBM Plex Sans, Helvetica Neue, Arial, sans-serif",
  colors: {
    brand: [
      "#ffeee7",
      "#ffdcd0",
      "#fab7a0",
      "#f78f6d",
      "#f36e41",
      "#f35925",
      "#f24e16",
      "#d83f0b",
      "#c13607",
      "#a92b00",
    ],
  },
  primaryColor: "brand",
  headings: {
    fontFamily: "IBM Plex Sans, Helvetica Neue, Arial, sans-serif",
    fontWeight: "700",
  },
  fontSizes: {
    xs: "12",
    sm: "14",
    md: "16",
    lg: "20",
    xl: "32",
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <MantineProvider withCssVariables={true} theme={theme}>
          <RouterProvider router={router} />
        </MantineProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
